import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["emailInput", "idInput", "options"]

  connect() {
    this.emailToId = new Map()
    this.idToEmail = new Map()

    Array.from(this.optionsTarget.options).forEach((option) => {
      const email = option.value.trim().toLowerCase()
      const id = option.dataset.userId
      if (!email || !id) return

      this.emailToId.set(email, id)
      this.idToEmail.set(id, option.value)
    })

    if (!this.emailInputTarget.value && this.idInputTarget.value) {
      this.emailInputTarget.value = this.idToEmail.get(this.idInputTarget.value) || ""
    }

    this.sync()
  }

  sync() {
    const email = this.emailInputTarget.value.trim().toLowerCase()
    this.idInputTarget.value = this.emailToId.get(email) || ""
  }
}
